import { render, staticRenderFns } from "./DeleteOutlined.vue?vue&type=template&id=f7c1f296&"
import script from "./DeleteOutlined.vue?vue&type=script&lang=js&"
export * from "./DeleteOutlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports